export default function ProductIntro() {
  return (
    <section id="product-intro" className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50">
      {/* Background Decoration */}
      <div className="absolute top-20 left-10 w-48 h-48 md:w-72 md:h-72 bg-[#FF9500]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-48 h-48 md:w-72 md:h-72 bg-[#FF9500]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="inline-block px-4 py-2 bg-[#FF9500]/10 text-[#FF9500] text-xs sm:text-sm font-semibold rounded-full mb-4 md:mb-6">
            PRODUCT INTRODUCTION
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-4">
            케어인슈 상품 소개
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 px-4">
            장기요양기관의 특성을 반영한 맞춤형 보험 상품으로<br className="hidden sm:block" />
            시설과 전문인을 동시에 보호합니다
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-12 md:mb-16 lg:mb-20">
          {/* Product 1 */}
          <div className="group bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border-2 border-[#FF9500]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="relative h-48 md:h-64 overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/793b12fd230edf50c798843611c44b12.jpg"
                alt="입소시설 보험"
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-4 md:bottom-6 left-4 md:left-6">
                <div className="inline-block px-3 md:px-4 py-1.5 md:py-2 bg-[#FF9500] text-white text-xs md:text-sm font-semibold rounded-full mb-2">
                  입소시설
                </div>
              </div>
            </div>
            <div className="p-6 md:p-8 lg:p-10">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">입소시설 전용 상품</h3>
              <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8">
                노인요양시설, 노인요양공동생활가정, 단기보호기관, 주야간보호기관을 위한 맞춤형 보험
              </p>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">정원/현원 기준 보험료</p>
                    <p className="text-xs md:text-sm text-gray-600">시설 규모에 맞는 합리적인 보험료 산정</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">24시간 보장</p>
                    <p className="text-xs md:text-sm text-gray-600">입소자 보호를 위한 전일 보장</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">시설 특성 반영</p>
                    <p className="text-xs md:text-sm text-gray-600">시설 유형별 맞춤 보장</p>
                  </div>
                </div>
              </div>
              
              {/* 영업배상 테이블 */}
              <div className="mb-6 md:mb-8 bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl overflow-hidden border border-gray-200">
                <div className="bg-gradient-to-r from-[#FF9500] to-[#FF7A00] px-4 md:px-6 py-3 md:py-4">
                  <h4 className="text-white font-bold text-base md:text-lg">영업배상</h4>
                </div>
                <div className="p-4 md:p-6">
                  <div className="bg-gradient-to-br from-[#FF9500]/5 to-[#FF7A00]/5 rounded-lg md:rounded-xl p-4 md:p-5 border border-[#FF9500]/20 mb-4">
                    <div className="text-xs text-[#FF9500] font-semibold mb-3">케어인슈 기본</div>
                    <div className="space-y-2">
                      <div className="flex justify-between items-center">
                        <span className="text-xs md:text-sm font-medium text-gray-700">1인당</span>
                        <span className="text-base md:text-lg font-bold text-[#FF9500]">1억 5천만원</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-xs md:text-sm font-medium text-gray-700">1사고당</span>
                        <span className="text-base md:text-lg font-bold text-[#FF9500]">5억원</span>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3 md:gap-4">
                    <div className="bg-blue-50 rounded-lg md:rounded-xl p-3 md:p-4 border border-blue-100">
                      <div className="flex items-start gap-2 md:gap-3">
                        <div className="w-4 h-4 md:w-5 md:h-5 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-information-line text-white text-[10px] md:text-xs"></i>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-xs md:text-sm font-semibold text-blue-900 mb-1">대물 보장</div>
                          <div className="text-[10px] md:text-xs text-blue-700">1사고당 <span className="font-bold">1천만원</span></div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-amber-50 rounded-lg md:rounded-xl p-3 md:p-4 border border-amber-100">
                      <div className="flex items-start gap-2 md:gap-3">
                        <div className="w-4 h-4 md:w-5 md:h-5 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-money-dollar-circle-line text-white text-[10px] md:text-xs"></i>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-xs md:text-sm font-semibold text-amber-900 mb-1">공제금액</div>
                          <div className="text-[10px] md:text-xs text-amber-700">건당 <span className="font-bold">50만원</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 전문인배상 테이블 */}
              <div className="mb-6 md:mb-8 bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl overflow-hidden border border-gray-200">
                <div className="bg-gradient-to-r from-[#4A90E2] to-[#357ABD] px-4 md:px-6 py-3 md:py-4">
                  <h4 className="text-white font-bold text-base md:text-lg">전문인배상</h4>
                </div>
                <div className="p-4 md:p-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mb-4">
                    <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-5 border border-gray-200 shadow-sm">
                      <div className="text-xs text-gray-500 mb-3">보장 내용</div>
                      <div className="space-y-3">
                        <div>
                          <div className="text-xs md:text-sm font-medium text-gray-700 mb-1">1사고당</div>
                          <div className="text-base md:text-lg font-bold text-[#4A90E2]">1억원</div>
                        </div>
                        <div>
                          <div className="text-xs md:text-sm font-medium text-gray-700 mb-1">연간 총보상 한도액</div>
                          <div className="text-base md:text-lg font-bold text-[#4A90E2]">1억원</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-br from-[#4A90E2]/5 to-[#357ABD]/5 rounded-lg md:rounded-xl p-4 md:p-5 border border-[#4A90E2]/20">
                      <div className="text-xs text-[#4A90E2] font-semibold mb-3">공제금액</div>
                      <div className="space-y-3">
                        <div>
                          <div className="text-xs md:text-sm font-medium text-gray-700 mb-1">기본</div>
                          <div className="text-base md:text-lg font-bold text-[#4A90E2]">건당 50만원</div>
                        </div>
                        <div>
                          <div className="text-xs md:text-sm font-medium text-gray-700 mb-1">Co-Insurance</div>
                          <div className="text-xs md:text-sm font-bold text-gray-700">손해액 1천만원 초과 10%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-amber-50 rounded-lg md:rounded-xl p-3 md:p-4 border border-amber-100">
                    <div className="flex items-start gap-2 md:gap-3">
                      <div className="w-4 h-4 md:w-5 md:h-5 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-shield-check-line text-white text-[10px] md:text-xs"></i>
                      </div>
                      <div className="text-[10px] md:text-xs text-amber-800 leading-relaxed">
                        요양보호사, 간호사, 사회복지사 등 전문인력의 업무상 과실로 인한 배상책임 보장
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Product 2 */}
          <div className="group bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border-2 border-[#FF9500]/20 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500">
            <div className="relative h-48 md:h-64 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20Korean%20female%20caregiver%20in%20uniform%20providing%20compassionate%20home%20visit%20care%20service%20to%20elderly%20Korean%20grandmother%20in%20bright%20comfortable%20Korean%20residential%20home%20showing%20warm%20caring%20interaction%20with%20Korean%20healthcare%20worker%20gently%20helping%20Korean%20senior%20woman%20with%20daily%20activities%20in%20cozy%20living%20room%20featuring%20Korean%20people%20quality%20in-home%20elderly%20care%20personal%20attention%20and%20heartwarming%20moment%20between%20Korean%20caregiver%20and%20Korean%20elderly%20patient%20with%20natural%20sunlight%20peaceful%20atmosphere%20traditional%20Korean%20home%20elements&width=800&height=500&seq=product-visit-korean-homecare-revised-030&orientation=landscape"
                alt="방문시설 보험"
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-4 md:bottom-6 left-4 md:left-6">
                <div className="inline-block px-3 md:px-4 py-1.5 md:py-2 bg-[#FF9500] text-white text-xs md:text-sm font-semibold rounded-full mb-2">
                  방문시설
                </div>
              </div>
            </div>
            <div className="p-6 md:p-8 lg:p-10">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">재가방문 전용 상품</h3>
              <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8">
                방문요양기관, 방문목욕기관을 위한 특화된 보험 상품
              </p>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">인력 기준 보험료</p>
                    <p className="text-xs md:text-sm text-gray-600">요양보호사/돌보미 수에 따른 산정</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">편리한 가입</p>
                    <p className="text-xs md:text-sm text-gray-600">인원 명단, 추가, 변경이 없습니다.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">방문 서비스 특화</p>
                    <p className="text-xs md:text-sm text-gray-600">일상생활 이동 중 사고 보장</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">돌봄통합지원 보장</p>
                    <p className="text-xs md:text-sm text-gray-600">돌봄(노인/장애인), 돌봄SOS 보장</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FF9500]/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#FF9500] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-semibold text-gray-900">유연한 보장</p>
                    <p className="text-xs md:text-sm text-gray-600">서비스 특성에 맞춘 설계</p>
                  </div>
                </div>
              </div>

              {/* 전문인배상 테이블 */}
              <div className="mb-6 md:mb-8 bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl overflow-hidden border border-gray-200">
                <div className="bg-gradient-to-r from-[#4A90E2] to-[#357ABD] px-4 md:px-6 py-3 md:py-4">
                  <h4 className="text-white font-bold text-base md:text-lg">전문인배상</h4>
                </div>
                <div className="p-4 md:p-6">
                  <div className="grid grid-cols-3 gap-3 md:gap-4">
                    <div className="bg-gradient-to-br from-[#4A90E2]/5 to-[#357ABD]/5 rounded-lg md:rounded-xl p-3 md:p-5 border border-[#4A90E2]/20">
                      <div className="text-xs text-[#4A90E2] font-semibold mb-2 md:mb-3">대인</div>
                      <div className="space-y-2">
                        <div>
                          <div className="text-[10px] md:text-xs text-gray-600 mb-1">1인당</div>
                          <div className="text-sm md:text-lg font-bold text-[#4A90E2]">5천만원</div>
                        </div>
                        <div>
                          <div className="text-[10px] md:text-xs text-gray-600 mb-1">1사고당</div>
                          <div className="text-sm md:text-lg font-bold text-[#4A90E2]">5천만원</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-blue-50 rounded-lg md:rounded-xl p-3 md:p-5 border border-blue-100">
                      <div className="text-xs text-blue-700 font-semibold mb-2 md:mb-3">대물</div>
                      <div className="space-y-2">
                        <div>
                          <div className="text-[10px] md:text-xs text-gray-600 mb-1">1사고당</div>
                          <div className="text-sm md:text-lg font-bold text-blue-700">1천만원</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-amber-50 rounded-lg md:rounded-xl p-3 md:p-5 border border-amber-100">
                      <div className="text-xs text-amber-700 font-semibold mb-2 md:mb-3">공제금액</div>
                      <div className="space-y-2">
                        <div>
                          <div className="text-[10px] md:text-xs text-gray-600 mb-1">건당</div>
                          <div className="text-sm md:text-lg font-bold text-amber-700">10만원</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 방문 서비스 이미지 */}
              <div className="rounded-xl md:rounded-2xl overflow-hidden shadow-lg">
                <img 
                  src="https://readdy.ai/api/search-image?query=warm%20heartwarming%20scene%20of%20professional%20Korean%20female%20home%20care%20worker%20in%20uniform%20visiting%20smiling%20Korean%20elderly%20woman%20at%20cozy%20Korean%20home%20providing%20gentle%20healthcare%20assistance%20and%20daily%20living%20support%20showing%20trust%20respect%20and%20compassionate%20care%20between%20Korean%20caregiver%20and%20Korean%20senior%20citizen%20in%20bright%20comfortable%20living%20room%20with%20natural%20lighting%20Korean%20cultural%20elements%20visible%20authentic%20Korean%20people%20realistic%20photography&width=800&height=450&seq=visit-service-korean-detail-003&orientation=landscape"
                  alt="방문 요양 서비스"
                  className="w-full h-60 md:h-80 object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        {/* 음식물배상책임 & 형사방어비용 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16 lg:mb-20">
          {/* 음식물배상책임 */}
          <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10 shadow-xl border-2 border-yellow-400/30 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-yellow-400 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-restaurant-2-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900">음식물배상책임</h3>
            </div>
            
            <div className="space-y-4 mb-6">
              <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-5 border border-yellow-200 shadow-sm">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm md:text-base font-semibold text-gray-700">1인당</span>
                  <span className="text-lg md:text-xl font-bold text-yellow-600">3천만원</span>
                </div>
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm md:text-base font-semibold text-gray-700">연간 총보상 한도액</span>
                  <span className="text-lg md:text-xl font-bold text-yellow-600">5천만원</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm md:text-base font-semibold text-gray-700">공제금액</span>
                  <span className="text-lg md:text-xl font-bold text-yellow-600">건당 50만원</span>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 rounded-lg md:rounded-xl p-4 md:p-5 border border-yellow-200">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-yellow-600 text-lg md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-sm md:text-base font-semibold text-gray-900 mb-2">급식 제공 시 필수 보장</p>
                  <p className="text-sm md:text-base text-gray-600">음식물 섭취로 인한 식중독 등 배상책임을 보장합니다</p>
                </div>
              </div>
            </div>
          </div>

          {/* 형사방어비용 */}
          <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10 shadow-xl border-2 border-purple-400/30 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-purple-400 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-scales-3-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900">형사방어비용</h3>
            </div>
            
            <div className="space-y-4 mb-6">
              <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-5 border border-purple-200 shadow-sm">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm md:text-base font-semibold text-gray-700">1사고당</span>
                  <span className="text-lg md:text-xl font-bold text-purple-600">5백만원</span>
                </div>
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm md:text-base font-semibold text-gray-700">연간 총보상 한도액</span>
                  <span className="text-lg md:text-xl font-bold text-purple-600">2천만원</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm md:text-base font-semibold text-gray-700">공제금액</span>
                  <span className="text-lg md:text-xl font-bold text-purple-600">없음</span>
                </div>
              </div>
            </div>

            <div className="bg-purple-50 rounded-lg md:rounded-xl p-4 md:p-5 border border-purple-200">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-purple-600 text-lg md:text-xl mt-0.5"></i>
                <div>
                  <p className="text-sm md:text-base font-semibold text-gray-900 mb-2">형사 소송 시 법률 비용 지원</p>
                  <p className="text-sm md:text-base text-gray-600">업무상 과실로 인한 형사 사건 발생 시 변호사 선임 비용을 지원합니다</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Benefits */}
        <div className="bg-[#FF9500] text-white rounded-3xl p-8 shadow-xl">
          <div className="text-center text-2xl md:text-3xl font-bold mb-6">모든 상품 공통 혜택</div>
          <div className="bg-white text-gray-800 rounded-2xl p-6 md:p-8">
            <div className="flex items-start gap-3 mb-6">
              <i className="ri-gift-line text-3xl text-[#FF9500] flex-shrink-0"></i>
              <p className="font-bold text-base md:text-lg">케어인슈 가입 시 모든 상품에서 제공되는 특별 혜택</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-[#FFF8F0] rounded-lg p-5 border-2 border-[#FF9500]/20">
                <div className="w-12 h-12 bg-[#FF9500] rounded-full flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-shield-star-line text-white text-xl"></i>
                </div>
                <h4 className="text-center font-semibold text-gray-900 mb-2">재가입 보장</h4>
                <p className="text-center text-sm text-gray-700">사고 후에도 계속 가입 가능</p>
              </div>
              <div className="bg-[#FFF8F0] rounded-lg p-5 border-2 border-[#FF9500]/20">
                <div className="w-12 h-12 bg-[#FF9500] rounded-full flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-user-star-line text-white text-xl"></i>
                </div>
                <h4 className="text-center font-semibold text-gray-900 mb-2">전담 손해사정</h4>
                <p className="text-center text-sm text-gray-700">전문가의 정확한 사고 분석</p>
              </div>
              <div className="bg-[#FFF8F0] rounded-lg p-5 border-2 border-[#FF9500]/20">
                <div className="w-12 h-12 bg-[#FF9500] rounded-full flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-customer-service-2-line text-white text-xl"></i>
                </div>
                <h4 className="text-center font-semibold text-gray-900 mb-2">상시 상담</h4>
                <p className="text-center text-sm text-gray-700">언제든 문의 가능한 지원</p>
              </div>
              <div className="bg-[#FFF8F0] rounded-lg p-5 border-2 border-[#FF9500]/20">
                <div className="w-12 h-12 bg-[#FF9500] rounded-full flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-scales-3-line text-white text-xl"></i>
                </div>
                <h4 className="text-center font-semibold text-gray-900 mb-2">법률 지원</h4>
                <p className="text-center text-sm text-gray-700">소송 시 법률 자문 제공</p>
              </div>
            </div>
            <p className="mt-6 text-center text-sm md:text-base text-gray-700">
              <strong>케어인슈의 모든 보험 상품</strong>은 위 4가지 핵심 혜택을 기본으로 제공합니다.<br />
              고객의 안정적인 시설 운영을 위해 최선을 다하겠습니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
